<!-- 🔴 ALL ORIGINAL STRUCTURE COMMENTED OUT LINE BY LINE -->
<!--<style>
	#cont {
		font-family: 'Source Sans Pro', Helvetica, Arial, sans-serif;
		text-align: center;
	}
	
	.custom-select>a.dropdown-toggle.disabled, .custom-select>a.dropdown-toggle.disabled:hover
		{
		cursor: not-allowed;
		color: #aaa;
		background: #eee;
	}
	...
	[All styles commented out]
</style>-->

<!-- STANDARD Modal Header -->
<div class="modal-header">
    <h3 class="modal-title">{{modalTitle}}</h3>
    <div class="header-actions">
      <i class="fa" 
         [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}" 
         style="margin-right: 10px; cursor: pointer;" 
         (click)="minimise=!minimise"></i>
      <i (click)="cancel()" class="fa fa-times" style="cursor: pointer;"></i>
    </div>
  </div>
  
  <!-- Modal Body -->
  <div class="modal-body" [ngStyle]="{'display': minimise ? 'none' : 'block'}">
    <div class="panel panel-default">
      <div class="panel-body">
        <div>
          <!-- First row with Entity and Adjustment Type -->
          <div class="row mb-30">
            <div class="col-xs-12 col-md-4">
              <label for="level" class="control-label">Entity</label>
              <select class="form-control" 
                      [class.disabled-field]="!isCreate"
                      [(ngModel)]="entity" 
                      (ngModelChange)="onEntityChange()"
                      [compareWith]="compareByKey"
                      [disabled]="!isCreate">
                <option value="">Select...</option>
                @for (item of entityDetails; track $index) {
<option [ngValue]="item">{{item.VALUE}}</option>
}
              </select>
            </div>
            <div class="form-group col-xs-12 col-md-2">
              <label for="level" class="control-label">Adjustment Type</label>
              <select class="form-control" 
                      [(ngModel)]="adjustmentType"
                      [compareWith]="compareByCodeKey">
                <option value="">Select...</option>
                @for (option of adjustmentTypeDetails; track $index) {
<option [ngValue]="option">{{option.CODE_DESCRIPTION}}</option>
}
              </select>
            </div>
          </div>
  
          <!-- Second row with SIC Code, Basket, and FDII -->
          <div class="row mb-30">
            <div class="form-group col-xs-12 col-md-2">
              <label for="level" class="control-label">SIC Code</label>
              <select class="form-control" 
                      [(ngModel)]="sicCode"
                      [compareWith]="compareByCodeKey">
                <option value="">Select...</option>
                @for (option of sicCodeDetails; track $index) {
<option [ngValue]="option">{{option.CODE_DESCRIPTION}}</option>
}
              </select>
            </div>
            
            <div class="form-group col-xs-12 col-md-2">
              <label for="level" class="control-label">Basket</label>
              <select class="form-control" 
                      [(ngModel)]="basket"
                      [compareWith]="compareByCodeKey">
                <option value="">Select...</option>
                @for (option of basketDetails; track $index) {
<option [ngValue]="option">{{option.CODE_DESCRIPTION}}</option>
}
              </select>
            </div>
            
            <div class="form-group col-xs-12 col-md-2">
              <label for="level" class="control-label">FDII</label>
              <select class="form-control" 
                      [(ngModel)]="fdii"
                      [compareWith]="compareByCodeKey">
                <option value="">Select...</option>
                @for (option of fdiiDetails; track $index) {
<option [ngValue]="option">{{option.CODE_DESCRIPTION}}</option>
}
              </select>
            </div>
          </div>
  
          <!-- Third row with amounts and comments -->
          <div class="row mb-30">
            <div class="form-group col-xs-12 col-md-2">
              <label for="level" class="control-label">Gross Receipts Adjustment</label>
              <input type="text" 
                     class="form-control" 
                     [(ngModel)]="adjustmentAmount" 
                     (keydown)="$event.keyCode === 69 ? $event.preventDefault() : null"
                     (keyup)="settingAdjustmentAmount($event)">
            </div>
            
            <div class="form-group col-xs-12 col-md-3">
              <label for="level" class="control-label">Gross Intangible Income Adjustment</label>
              <input type="text" 
                     class="form-control" 
                     [(ngModel)]="adjAmount" 
                     (keydown)="$event.keyCode === 69 ? $event.preventDefault() : null"
                     (keyup)="settingAdjAmount($event)">
            </div>
            
            <div class="form-group col-xs-12 col-md-4">
              <label for="level" class="control-label">Comments</label>
              <textarea maxlength="500" 
                        class="form-control" 
                        [(ngModel)]="comments" 
                        style="">
              </textarea>
              <div style="text-align: right; font-weight: normal; vertical-align: bottom;">
                <label style="font-weight: normal; font-size: x-small; color: gray;">Max length 500</label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  
  <!-- STANDARD Footer -->
  <div class="modal-footer" [ngStyle]="{'display': minimise ? 'none' : 'block'}">
    <button class="save-button"  
            type="button"  
            [disabled]="isSaveClicked"  
            (click)="save()"> 
      @if (crudLoading) {
<span><i class="fa fa-spinner fa-pulse"></i></span>
}Save
    </button>
    <button class="reset-button"  
            type="button"  
            (click)="reset()">Reset</button>
    <button class="cancel-button"  
            type="button"  
            (click)="cancel()">Cancel</button>
  </div>
  